import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { initAnalyticsIfConsented, handleConsentUpdated } from "./lib/analytics";

// Initialize GA if user already consented
initAnalyticsIfConsented();

// React to consent updates (banner or settings page)
window.addEventListener('cookie-consent-updated', (e: Event) => {
  // @ts-expect-error custom event detail
  const detail = (e as CustomEvent).detail;
  if (detail) handleConsentUpdated(detail);
});

createRoot(document.getElementById("root")!).render(<App />);
